import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { HeadMetadata } from '../../../../components/HeadMetadata';
import { Header, HeaderWrapper } from '../../../../components/Header';
import { confirmSignIn } from '@aws-amplify/auth';
import { FullScreenSpinner } from '../../../../components/Spinners/FullScreenSpinner';
import { SignInState } from '../../types';
import { Description } from '../../../../components/Description';
import {
  SignInConfirmationWithNewPasswordDTO,
  SignInConfirmationWithNewPasswordForm
} from '../../components/SignInConfirmationWithNewPassword/SignInConfirmationWithNewPassword';
import { signInOutputHandler } from '../../utils/signInOutputHandler';

export function SignInWithNewPasswordRequiredPage() {
  const navigator = useNavigate();
  const [fullScreenSpinnerOnScreen, setFullScreenSpinnerOnScreen] = useState(false);
  const [formError, setFormError] = useState<unknown>('');
  const location = useLocation();
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const { user } = useAuthenticator((context) => {
    return [context.user];
  });

  async function handleSubmit(formData: SignInConfirmationWithNewPasswordDTO) {
    setFullScreenSpinnerOnScreen(true);
    setFormError('');

    try {
      const signInConfirmationResult = await confirmSignIn({
        challengeResponse: formData.password
      });

      setFullScreenSpinnerOnScreen(false);

      if (signInConfirmationResult.nextStep.signInStep === SignInState.CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE) {
        signInOutputHandler(
          signInConfirmationResult,
          navigator,
          {
            username: signInConfirmationResult.nextStep.additionalInfo?.email,
            password: formData.password
          },
          {
            location: location.state?.location,
            search: location.search
          }
        );
      }

      if (signInConfirmationResult.nextStep.signInStep === SignInState.DONE) {
        setUserLoggedIn(true);
      }
    } catch (error) {
      setFullScreenSpinnerOnScreen(false);

      showFormError(error);
    }
  }

  function showFormError(error: unknown) {
    const errorText = `${error}`.split('tion: ').pop();

    setFormError(errorText);
  }

  if (userLoggedIn || user) {
    return (
      <Navigate
        to={location.state ? location.state.location : '/account'}
        replace={true}
      />
    );
  }

  return (
    <>
      <HeadMetadata title={'Mint Medical Subscription Store | Sign In With New Passwords'}></HeadMetadata>

      <HeaderWrapper>
        <Header>Welcome to the Mint Medical Subscription Store</Header>
      </HeaderWrapper>

      {fullScreenSpinnerOnScreen && <FullScreenSpinner></FullScreenSpinner>}
      <Description>Set up new passwords.</Description>

      <div className="mx-auto w-full bg-white md:w-2/6">
        <SignInConfirmationWithNewPasswordForm
          submissionError={formError}
          onSubmit={handleSubmit}></SignInConfirmationWithNewPasswordForm>
      </div>
    </>
  );
}
